import { Card, Col, Row, Typography } from 'antd';

function Home() {
  return (
    <div className='Home'>
      <Row gutter={16}>
        <Col span={12}>
          <Card>
            <Typography.Paragraph>40K Team Admin</Typography.Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Home;
